module.exports = __webpack_public_path__ + "static/media/ptaki.30c718c6.svg";